import { render, staticRenderFns } from "./SubJobStageSetup.vue?vue&type=template&id=fe7d8d98&scoped=true"
import script from "./SubJobStageSetup.vue?vue&type=script&lang=js"
export * from "./SubJobStageSetup.vue?vue&type=script&lang=js"
import style0 from "./SubJobStageSetup.vue?vue&type=style&index=0&id=fe7d8d98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7d8d98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe7d8d98')) {
      api.createRecord('fe7d8d98', component.options)
    } else {
      api.reload('fe7d8d98', component.options)
    }
    module.hot.accept("./SubJobStageSetup.vue?vue&type=template&id=fe7d8d98&scoped=true", function () {
      api.rerender('fe7d8d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/SubJobStageSetup.vue"
export default component.exports